import { Component, Input, OnChanges } from '@angular/core';
import { UserAvatarService } from 'src/app/api-providers/services/user-avatar.service';

@Component({
  selector: 'app-user-display',
  templateUrl: './user-display.component.html',
  styleUrls: ['./user-display.component.scss']
})
export class UserDisplayComponent implements OnChanges {
  @Input() userId?: number | string | null;
  @Input() userName?: string | null;
  @Input() userEmail?: string | null;
  @Input() imageUrl?: string | null;
  @Input() size = 24;
  @Input() showName = true;

  avatarSrc: string | null = null;
  avatarError = false;

  constructor(private userAvatarService: UserAvatarService) {}

  ngOnChanges(): void {
    this.avatarError = false;
    this.avatarSrc = this.userAvatarService.getPhotoFor({
      userId: this.userId,
      userName: this.userName,
      userEmail: this.userEmail,
      imageUrl: this.imageUrl
    });
  }

  get displayName(): string {
    return (this.userName || '').trim() || 'NA';
  }

  get initials(): string {
    const nameParts = this.displayName.split(/\s+/).filter(Boolean);
    if(this.displayName == 'NA' || nameParts.length == 0){
      return '';
    }
    return nameParts.slice(0, 2).map(part => part.charAt(0).toUpperCase()).join('');
  }

  showFallbackAvatar(): void {
    this.avatarError = true;
    this.avatarSrc = null;
  }
}
